<template>
  <div class="page">

    <div
      class="groups-query-list card"
      :class="{ '-loading': loading }"
    >
      <loader v-if="loading"></loader>

      <div class="header">
        <div class="description">
          <h1 class="title">Criar Template</h1>
        </div>
      </div>

      <div class="body">
        <validation-observer ref="form">
          <form action="" @submit.prevent="submitForm">
            <validation-provider v-slot="{ errors }" rules="required">
              <div class="group-fields" style="border-width: 0">
                <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
                  <label for="template-name" class="label w-full">Nome do template</label>
                  <input
                    class="form-control"
                    id="template-name"
                    type="text"
                    placeholder="Nome do template"
                    v-model="name"
                    autocomplete
                    required
                  >

                  <p class="description" v-if="errors.length > 0">{{ errors[0] }}</p>
                </div>
              </div>
            </validation-provider>

            <validation-provider v-slot="{ errors }" rules="required">
              <div class="group-fields">
                <legend class="groupTitle">Selecionar Documento</legend>

                <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
                  <multiselect
                    :options="formattedDocuments"
                    :multiple="false"
                    class="form-control"
                    label="label"
                    track-by="name"
                    id="consultations"
                    placeholder="Selecione uma opção"
                    select-label="Pressione enter para selecionar"
                    selected-label="Selecionado"
                    deselect-label="Pressione enter para remover"
                    v-model="tags"
                  ></multiselect>
                  <p class="description" v-if="errors.length > 0">{{ errors[0] }}</p>
                </div>
              </div>
            </validation-provider>

            <button type="submit" class="btn btn-success">
              <ion-icon name="save"></ion-icon>
              Salvar
            </button>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/support/components/Loader.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Multiselect from 'vue-multiselect';
import unCamelCase from '@/support/filters/unCamelCase';

export default {
  name: 'Create',

  components: {
    Loader,
    ValidationProvider,
    ValidationObserver,
    Multiselect,
  },

  data() {
    return {
      name: '',
      tags: [],
      loading: false,
    };
  },

  computed: {
    ...mapState('template', [
      'template',
    ]),
    ...mapState('compliance', {
      documents: 'documents',
    }),
    formattedDocuments() {
      return this.documents.map((item) => ({
        name: item.name,
        label: unCamelCase(item.name),
      }));
    },
  },

  methods: {
    async createTemplate() {
      this.loading = true;
      await this.$store.dispatch('template/createTemplate', {
        name: this.name,
        tag: this.tags.name,
      });
      this.$notify({
        group: 'app',
        type: 'success',
        title: 'Sucesso!',
        text: 'Template criado com sucesso.',
      });
      this.loading = false;
      await this.$router.push({
        name: 'Template-Other',
      });
    },

    async loadTemplate() {
      await this.$store.dispatch('template/fetchTemplate', this.$route.params.id);
    },

    async fetchDocumentsList() {
      await this.$store.dispatch('compliance/fetchDocumentsList');
    },

    async submitForm() {
      const valid = await this.$refs.form.validate();

      if (valid) {
        await this.createTemplate();
      }

      return valid;
    },
  },

  mounted() {
    try {
      this.loading = true;

      this.fetchDocumentsList();
    } finally {
      this.loading = false;
    }
  },

  filters: {
    unCamelCase,
  },
};
</script>

<style lang="scss" scoped>

</style>
